import { ReactNode } from 'react'
import { Text } from './Typography'

interface StatCardProps {
    label: string
    value: string | number
    subtitle?: string
    dot?: string
    icon?: ReactNode
    onClick?: () => void
    className?: string
    'data-testid'?: string
}

export const StatCard = ({ label, value, subtitle, dot, icon, onClick, className = '', ...props }: StatCardProps) => (
    <div
        data-testid={props['data-testid']}
        className={`flex items-center gap-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2 transition-all ${onClick ? 'cursor-pointer hover:border-slate-300 dark:hover:border-slate-600 hover:shadow-sm' : ''} ${className}`}
        onClick={onClick}
    >
        {dot && <div className={`h-8 w-1 shrink-0 rounded-full ${dot}`} />}
        {icon && <div className="shrink-0">{icon}</div>}
        <div className="min-w-0 flex-1">
            <Text variant="overline" as="div" className="text-[11px]">
                {label}
            </Text>
            <Text variant="h4" as="div" className="truncate">
                {value}
            </Text>
            {subtitle && (
                <Text variant="caption" as="div" className="truncate">
                    {subtitle}
                </Text>
            )}
        </div>
    </div>
)

interface StatCardSkeletonProps {
    className?: string
}

export const StatCardSkeleton = ({ className = '' }: StatCardSkeletonProps) => (
    <div className={`rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2 animate-pulse ${className}`}>
        <div className="flex items-center gap-3">
            <div className="h-8 w-1 shrink-0 rounded-full bg-slate-200 dark:bg-slate-700" />
            <div className="min-w-0 flex-1 space-y-1.5">
                <div className="h-2.5 w-16 rounded bg-slate-200 dark:bg-slate-700" />
                <div className="h-4 w-24 rounded bg-slate-200 dark:bg-slate-700" />
            </div>
        </div>
    </div>
)
